export default __webpack_public_path__ + "static/media/883.9ff70952.gif";